document.addEventListener("DOMContentLoaded", function() {
    const typewriter = document.getElementById('typewriter');
    const cursor = document.getElementById('cursor');
    let typingTimeout;
    let fullText = '';
  
    function startTyping(text) {
      if (!typewriter) return;
      let i = 0;
      let out = '';
      cursor.style.opacity = 1;
  
      function type() {
        if (i < text.length) {
          out += text[i] === '\n' ? '<br>' : text[i];
          typewriter.innerHTML = out;
          i++;
          typingTimeout = setTimeout(type, 60);
        }
      }
  
      clearTimeout(typingTimeout);
      type();
    }
  
    function updateTextByWidth() {
      const newText = window.innerWidth > 1024 
        ? 'Health & Nutrition\nbacked by doctors' 
        : 'Health & Nutrition\nbacked by doctors';

      if (fullText !== newText) {
        fullText = newText;
        startTyping(fullText);
      }
    }
  
    updateTextByWidth();
    window.addEventListener('resize', updateTextByWidth);
  });